<template>
  <div>
    <b-list-group style="max-width: 17rem; position: absolute; z-index: 9999; right: 10px">
      <b-list-group-item class="d-flex justify-content-between align-items-center p-2">
        <center><h5>Управление</h5></center>
        <i class="fa fa-compress fa-lg m-1" @click="controlArea = false" aria-hidden="true" v-if="controlArea"></i
        ><i class="fa fa-expand fa-lg m-1" @click="controlArea = true" aria-hidden="true" v-else></i>
      </b-list-group-item>
      <b-list-group-item v-if="controlArea && 1 !== 1" class="d-flex justify-content-between align-items-center p-1">
        Расчитать автоматические<br />
        вероятности
        <b-form-radio-group
          id="btn-radios-2"
          size="sm"
          class="p-1 m-1 pull-right"
          v-model="object.defaultTree"
          :options="[
            { text: 'Да', value: 1 },
            { text: 'Нет', value: 0 },
          ]"
          button-variant="outline-primary"
          buttons
          @change="fetchData"
          name="radios-btn-default"
        ></b-form-radio-group>
      </b-list-group-item>
      <b-list-group-item v-if="controlArea" class="d-flex justify-content-between align-items-center p-1">
        Cтандартное дерево
        <b-form-radio-group
          id="btn-radios-2"
          size="sm"
          class="p-1 m-1 pull-right"
          v-model="object.defaultTree"
          :options="[
            { text: 'Да', value: 1 },
            { text: 'Нет', value: 0 },
          ]"
          button-variant="outline-primary"
          buttons
          @change="goToConstructor()"
          name="radios-btn-default"
        ></b-form-radio-group>
      </b-list-group-item>
      <b-list-group-item
        v-if="controlArea && object.defaultTree != 1"
        class="d-flex justify-content-between align-items-center p-1"
      >
        <span v-if="object.defaultTree != 1"
          >Показать элементы<br />
          управления</span
        >
        <b-form-radio-group
          size="sm"
          v-if="object.defaultTree != 1"
          class="p-1 m-1 pull-right"
          id="btn-radios-1"
          v-model="control"
          :options="[
            { text: 'Да', value: true },
            { text: 'Нет', value: false },
          ]"
          button-variant="outline-primary"
          buttons
          name="radios-btn-default"
        ></b-form-radio-group>
      </b-list-group-item>
      <b-list-group-item
        v-if="object.defaultTree != 1 && controlArea"
        class="d-flex justify-content-between align-items-center p-1"
      >
        <span v-if="object.defaultTree != 1"
          >Загрузить стандартное<br />
          дерево событий</span
        >
        <b-btn class="pull-right" v-b-modal.load><i class="fa fa-download fa-lg"></i></b-btn>
      </b-list-group-item>
      <b-list-group-item v-if="controlArea" class="d-flex justify-content-between align-items-center p-1">
        <p class="p-1 m-1"></p>
        <h6 class="pt-2">Условные обозначения</h6>
      </b-list-group-item>
      <b-list-group-item v-if="controlArea" class="d-flex justify-content-between align-items-center p-1">
        <p class="p-1 m-1">
          P - условная вероятность<br />
          Q - частота возникновения события, год<sup>-1</sup>
        </p>
      </b-list-group-item>
      <b-list-group-item v-if="controlArea" class="d-flex justify-content-between align-items-center p-1">
        <p></p>
        <h6 class="p-3">
          <b-badge class="mr-1">P<sub>т</sub></b-badge>
        </h6>
        - У события с этим знаком учитывается вероятность эффективного срабатывания системы пожаротушения.
      </b-list-group-item>
      <b-list-group-item v-if="controlArea" class="d-flex justify-content-between align-items-center p-1">
        <p></p>
        <h6 class="p-3">
          <b-badge>P<sub>c</sub></b-badge>
        </h6>
        - У события с этим знаком учитывается вероятность эффективного срабатывания системы сигнализации.
      </b-list-group-item>
    </b-list-group>
    <div id="wrapper">
      <span class="label">
        <div
          class="m-1"
          style="line-height: 15px !important; position: absolute; top: 50%; transform: translateY(-50%)"
        >
          {{ object.name }}
        </div></span
      >
      <div class="branch">
        <branch
          @remove="remove($event)"
          @edit="edit($event, branch.outflow_type)"
          @actionAdd="actionAdd($event)"
          v-for="(branch, b_index) in tree"
          :key="b_index"
          :control="control"
          :branch="branch"
          :outflow="Number(branch.outflow_type)"
          :logic="logic"
          :index="b_index"
          :Q="parseFloat(branch.P)"
          :sole="tree.trees && tree.trees.length == 1 ? true : false"
          :devNames="devNames"
        >
        </branch>
        <div v-if="control == true" class="entry" v-bind:class="{ sole: tree && tree.length == 0 }">
          <span class="label" ref="label">
            <div
              class="m-1"
              style="
                line-height: 15px !important;
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                width: 140px;
              "
            >
              <b-button variant="success" @click="initAdd()">Добавить</b-button>
            </div>
          </span>
        </div>
      </div>
    </div>
    <b-modal id="newInit" ref="newInit" hide-footer title="Создать сценарий">
      <newInit
        @initUpdate="initUpdate($event)"
        @initPush="initPush($event)"
        :init.sync="cur_init"
        :outflows="outflows"
        :object="object"
        @hideActionWindow="$refs.newInit.hide()"
        @clearCalculations="$emit('clearCalculations')"
      ></newInit>
    </b-modal>
    <b-modal id="newAction" ref="newAction" hide-footer title="Создать сценарий">
      <newBranch
        :parent="cur_parent"
        @updateBranch="updateBranch($event)"
        :outflow="cur_outflow"
        :branch.sync="cur_branch"
        :object="object"
        @hideActionWindow="$refs.newAction.hide()"
        :logic="logic"
        :devNames="devNames"
        @clearCalculations="$emit('clearCalculations')"
      ></newBranch>
    </b-modal>
    <b-modal id="load" ref="load" hide-footer>
      <div class="d-block text-center">
        <h4>
          Все созданные для этого объекта сценарии будут потеряны. Вы действительно хотите загрузить стандартное дерево
          развития пожароопасных событий?
        </h4>
      </div>
      <b-btn
        class="mt-3 btn-outline"
        variant="danger"
        block
        @click="
          loadDefault();
          $refs.load.hide();
        "
        >Загрузить
      </b-btn>
    </b-modal>
  </div>
</template>

<script>
import newBranch from "./tree/newBranch";
import branch from "./tree/branch";
import newInit from "./tree/newInit";
export default {
  name: "tree",
  props: {
    object: Object,
    project: Object,
  },
  data() {
    return {
      controlArea: true,
      tree: null,
      calculated: false,
      outflows: [],
      devNames: null,
      loading: false,
      control: true,
      logic: [],
      cur_init: {},
      cur_branch: {},
      cur_parent: {},
      cur_outflow: null,
    };
  },
  components: {
    branch,
    newBranch,
    newInit,
  },
  created() {
    this.fetchData();
  },
  watch: {
    object: function () {
      this.fetchData();
    },
  },
  methods: {
    initAdd() {
      this.cur_init = {};
      this.$refs.newInit.show();
    },
    initPush(init) {
      this.tree.push(init);
      this.$emit("clearCalculations");
    },
    initUpdate(init) {
      Object.assign(this.cur_init, init);
      this.$emit("clearCalculations");
    },
    actionAdd(event) {
      this.cur_parent = event[0];
      this.cur_branch = {};
      this.cur_outflow = event[1];
      this.$refs.newAction.show();
    },
    loadDefault() {
      this.$http
        .get("risk/tree/load-default?id=" + this.object.id + "&obj_type=" + this.object.obj_type)
        .then((response) => {
          // JSON responses are automatically parsed.
          this.tree = response.data.tree;
          this.devNames = response.data.devNames;
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => this.$emit("clearCalculations"));
    },
    goToConstructor() {
      this.$http
        .get("risk/tree/go-to-constructor?id=" + this.object.id + "&obj_type=" + this.object.obj_type)
        .then((response) => {
          // JSON responses are automatically parsed.
          this.object.defaultTree = response.data.defaultTree;
          this.control = response.data.defaultTree == 1 ? false : true;
          this.tree = response.data.tree;
          this.devNames = response.data.devNames;
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => this.$emit("clearCalculations"));
    },
    edit(branch, outflow) {
      if (!branch.parent || branch.parent == 0) {
        this.cur_init = branch;
        this.$refs.newInit.show();
      } else {
        this.cur_branch = branch;
        this.cur_outflow = outflow;
        this.$nextTick(() => {
          this.$refs.newAction.show();
        });
      }
      this.$emit("clearCalculations");
    },
    updateBranch(branch) {
      Object.assign(this.cur_branch, branch);
      this.$emit("clearCalculations");
    },
    remove(params) {
      var id = params[0];
      var index = params[1];
      this.$http
        .post("risk/tree/remove?id=" + id)
        .then(() => {
          this.tree.splice(index, 1);
        })
        .catch((e) => {
          alert("Ошибка", e);
        })
        .finally(() => this.$emit("clearCalculations"));
    },
    toNormal(val) {
      if (String(val).includes("e-")) {
        val = String(val);
        val = val.split("e-");
        return parseFloat(val[0]).toFixed(2) + "⋅10<sup>-" + val[1] + "</sup>";
      } else {
        val = String(val);
        var multiply = 0;
        for (var i in val) {
          if (val[i] == "0" || val[i] == ".") {
            multiply++;
          } else {
            break;
          }
        }
        if (multiply > 3) {
          val = val * Math.pow(10, multiply - 1);
          parseFloat(val).toFixed(2);
          return Math.floor(val * 100) / 100 + "⋅10<sup>-" + (multiply - 1) + "</sup>";
        } else {
          return val;
        }
      }
    },
    fetchData(calc = 0) {
      this.loading = true;
      this.$http
        .get("risk/tree/show-tree?id=" + this.object.id + "&obj_type=" + this.object.obj_type + "&calc=" + calc)
        .then((response) => {
          // JSON responses are automatically parsed.
          this.tree = response.data.tree;
          this.outflows = response.data.outflows;
          this.logic = response.data.logic;
          this.devNames = response.data.devNames;
          this.loading = false;
          if (this.object.defaultTree == 1) {
            this.control = false;
          }
          if (calc == 0) {
            this.calculated = false;
          } else {
            this.calculated = true;
          }
        })
        .catch((e) => {
          console.error(e);
        });
    },
  },
};
</script>

<style lang="scss">
//------- {{ Variables }} -------//

$white: #eee9dc;
$bg: #2e6ba7;

$horizontal-gutter: 20px;
$border-radius: 10px;

$entry-min-height: 130px;

$label-width: 160px;
$label-height: 10px;
$label-border-radius: 5px;

//------- {{ Styles }} -------//

body {
  margin: 0;

  font: 16px Verdana, sans-serif;
  background: $bg;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

#wrapper {
  position: relative;
  margin-bottom: 50px;
}

.branch {
  position: relative;
  margin-left: $horizontal-gutter + $label-width;
  &:before {
    content: "";
    width: $horizontal-gutter / 2;
    border-top: 2px solid $white;
    position: absolute;
    left: -$horizontal-gutter;
    top: 50%;
    margin-top: 61px;
  }
}

.entry {
  position: relative;
  min-height: $entry-min-height;
  &:before {
    content: "";
    height: 100%;
    border-left: 2px solid $white;
    position: absolute;
    left: -($horizontal-gutter / 2);
    margin-top: 60px;
  }
  &:after {
    content: "";
    width: $horizontal-gutter / 2;
    border-top: 2px solid $white;
    position: absolute;
    left: -($horizontal-gutter / 2);
    top: 50%;
    margin-top: 61px;
  }
  &:first-child {
    &:before {
      width: $border-radius;
      height: 50%;
      top: 50%;
      margin-top: 62px;
      border-radius: $border-radius 0 0 0;
    }
    &:after {
      height: $border-radius;
      border-radius: $border-radius 0 0 0;
    }
  }
  &:last-child {
    &:before {
      width: $border-radius;
      height: 50%;
      border-radius: 0 0 0 $border-radius;
    }
    &:after {
      height: $border-radius;
      border-top: none;
      border-bottom: 2px solid $white;
      border-radius: 0 0 0 $border-radius;
      margin-top: -$border-radius + 61px;
    }
  }
  &.sole {
    &:before {
      display: none;
    }
    &:after {
      width: $horizontal-gutter / 2;
      height: 0;
      margin-top: 61px;
      border-radius: 0;
    }
  }
}

.label {
  display: block;
  width: $label-width;
  padding: 3px 3px;
  line-height: $label-height - 5px * 2;
  text-align: center;
  border: 2px solid $white;
  border-radius: $label-border-radius;
  position: absolute;
  left: 0;
  top: 50%;
  margin-top: -($label-height / 2);
  height: $entry-min-height - 10px;
}
</style>
